module.exports = "<p>\n  order-edit works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/order/order-edit/order-edit.component.html
// module id = ../../../../../src/app/pos/home/order/order-edit/order-edit.component.html
// module chunks = main